exports = module.exports = require("../../../../../_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * NutUI v2.2.1 - tabpanel.css, 59c3ac9b1672465eeb23, 2020-03-09T09:06:03+08:00\n * (c) 2017-2019 JDC\n * Released under the MIT License.\n */", ""]);

// exports
